import React from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const LocationDetailHeader = ({ title, name, description }) => {
  return (
    <React.Fragment>
      <Box mb={0.25}>
        <Typography variant="h5">{title}</Typography>
      </Box>
      <Typography variant="h1">{name}</Typography>
      <Box mt={1} mb={0.5}>
        <Typography>{description}</Typography>
      </Box>
    </React.Fragment>
  );
};

LocationDetailHeader.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string
};

export default LocationDetailHeader;
